export function generateVerificationToken() {
  const currentTime = new Date();
  const emailVerificationToken = generateToken(20);
  // 10 mins expiry time
  const emailVerificationExpiration = new Date(
    currentTime.getTime() + 10 * 60000
  );
  return { emailVerificationToken, emailVerificationExpiration };
}

export function generateAccessPin() {
  return generateToken(7, true);
}

// verification token generation
function generateToken(length: number, withoutSpecialChars?: true) {
  const characters = withoutSpecialChars
    ? "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    : "-.~_$@!ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let code = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    code += characters.charAt(randomIndex);
  }

  return code;
}

// password requirements
export const passwordRequirements = [
  { re: /.{8,}/, label: "≥ 8 characters" },
  { re: /[0-9]/, label: "Includes number" },
  { re: /[a-z]/, label: "Includes lowercase letter" },
  { re: /[A-Z]/, label: "Includes uppercase letter" },
  { re: /[$&+,:;=?@#|'<>.^*()%!-]/, label: "Includes special symbol" },
];
// generate random password
export function generatePassword() {
  // all chars avilable given current password requirements
  const allChars =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789$&+,:;=?@#|'<>.^*()%!-";
  let password = "";
  // Add one character per requirement to ensure each is met
  passwordRequirements.forEach((req) => {
    let matchingChars = allChars.split("").filter((char) => req.re.test(char));
    password += matchingChars[Math.floor(Math.random() * matchingChars.length)];
  });
  // password uses length of 8 at the moment
  while (password.length < 8) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }
  // Shuffle password for randomness
  password = password
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("");
  return password;
}
